import type IsoDate from '../../../models/IsoDate';
import type ParticipantCycleDataModel from '../../../models/ParticipantCycleDataModel';
import { requestAndParse, requestSuccessful } from '../request';

const getParticipantCycleData = async (
    participantId: number,
    cycleStart: IsoDate,
) => {
    const route = 'admin/get-participant-cycle-data';
    const payload = { participantId, cycleStart };

    const response = await requestAndParse(route, payload, 'GET');

    const success = requestSuccessful(response);
    const data = response.body as ParticipantCycleDataModel;

    return { success, data };
};

export default getParticipantCycleData;
